module.exports = __webpack_public_path__ + "img/46CASACCA-ROSA-SML-COLORI-LINO-STAMPE-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO8.c868bada.jpg";